const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationCardDeck',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
			<!-- InputType ObservationCardDeck {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}" id="CARD-DECK-CONTAINER-FOR-{~D:Record.Macro.RawHTMLID~}">
				<div class="field">
					<label id="LABEL-FOR-{~D:Record.Macro.RawHTMLID~}" for="CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} mr-4">{~LabelWithChips:Record~}</label>
					<!-- Hidden input to store/validate the observation card deck Observation Set (if using Observation Sets, if not, this will remain empty and unused) -->
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="text"
						class="input is-hidden"
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.InputFullProperties~}
						{~D:Record.Macro.InputChangeHandler~}
						value=""
					/>
					<!-- Card Deck UI -->
					<div class="observation-card-deck">
						<div class="observation-card-deck-header">
							<!-- container for filter tags that get dynamically generated based on the filters applied to the deck, if any -->
							<div id="CARD-DECK-HEADER-FILTERS-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-filters {~Hide:Record.PictForm.CardDeckSettings.useObservationSetSelector~}"></div>
							<!-- hidden input to store the currently selected observation set to exclude from the card deck, used when showSetSelector option is true and the user selects a set to exclude from the deck via the filter dropdown -->
							<input id="CARD-DECK-HEADER-EXCLUDE-OBSERVATION-SET-HIDDEN-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" type="hidden" value="{~D:Record.PictForm.CardDeckSettings.excludeObservationSets~}"/>
							<!-- static content in the header that shows the current set name if using a set without the set selector (gray tags similar to filter tags) -->
							<div id="CARD-DECK-HEADER-OBSERVATION-SET-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-observation-set-display {~Hide:Record.PictForm.CardDeckSettings.useObservationSetSelector~}"></div>
							<!-- set selector for non-sets use case or for when showSetSelector option is true (used instead of filters above) -->
							<div id="CARD-DECK-HEADER-OBSERVATION-SET-SELECTOR-CONTAINER-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-observation-set-selector {~Show:Record.PictForm.CardDeckSettings.useObservationSetSelector~}">
								<div class="field has-addons has-addons-right has-addons-left is-fullwidth mr-1 mb-0">
									<p class="control">
										<button
											id="EDIT-BUTTON-FOR-CARD-DECK-HEADER-OBSERVATION-SET-SELECTOR-FOR-{~D:Record.Macro.RawHTMLID~}"
											class="button is-link"
											type="button"
											disabled
											onclick="_Pict.providers.ObservationCardDeckProvider.handleObservationSetEditButtonClick('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}')"
											>
											<span class="icon">
												<i class="fa fa-fw fa-cog"></i>
											</span>
										</button>
									</p>
									<p class="control control-status select is-fullwidth">
										<span class="control-status-icon"></span>
										<select
											id="CARD-DECK-HEADER-OBSERVATION-SET-SELECTOR-FOR-{~D:Record.Macro.RawHTMLID~}"
											{~Required:Record~}
											{~Disabled:Record~}
											onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
										>
											<option value="">Select a set...</option>
										</select>
									</p>
									<p class="control">
										<button
											id="CREATE-BUTTON-FOR-CARD-DECK-HEADER-OBSERVATION-SET-SELECTOR-FOR-{~D:Record.Macro.RawHTMLID~}"
											class="button is-link"
											type="button"
											onclick="_Pict.providers.ObservationCardDeckProvider.handleObservationSetCreateSetButtonClick('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}')"
										>
											<span class="icon">
												<i class="fa fa-fw fa-plus"></i>
											</span>
											<span>Create New Set</span>
										</button>
									</p>
								</div>
							</div>
							<!-- Action buttons for the card deck -->
							<div id="CARD-DECK-HEADER-ACTIONS-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-actions">
								<div class="buttons has-addons observation-card-deck-style-toggle mr-1 mb-0">
									<button type="button" 
										class="button is-active" 
										title="Thumbnail" 
										data-deck-style="thumbnail" 
										onclick="_Pict.providers.ObservationCardDeckProvider.toggleDeckStyle('CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}', 'thumbnail')">
										<span class="icon">
											<i class="fa fa-fw fa-th"></i>
										</span>
									</button>
									<button type="button"
										class="button"
										title="List"
										data-deck-style="list"
										onclick="_Pict.providers.ObservationCardDeckProvider.toggleDeckStyle('CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}', 'list')">
										<span class="icon">
											<i class="fa fa-fw fa-list"></i>
										</span>
									</button>
									<button type="button"
										class="button"
										title="Details"
										data-deck-style="details"
										onclick="_Pict.providers.ObservationCardDeckProvider.toggleDeckStyle('CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}', 'details')">
										<span class="icon">
											<i class="fa fa-fw fa-id-card"></i>
										</span>
									</button>
								</div>
								<div class="buttons has-addons mb-0 {~Hide:Record.PictForm.CardDeckSettings.preventAddingCards~}">
									<button type="button"
										id="CARD-DECK-HEADER-ACTIONS-ADD-BUTTON-FOR-{~D:Record.Macro.RawHTMLID~}"
										class="button is-link is-skeleton" 
										title="Add" 
										data-deck-action="add" 
										onclick="_Pict.providers.ObservationCardDeckProvider.handleAddNewCardToDeckButtonEvent(event, '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', false)">
										<span class="icon">
											<i class="fa fa-fw fa-plus"></i>
										</span>
										<span class="icon-text">Add</span>
									</button>
									<!-- Quick capture button - actually a file input styled as a button -->
									<label
										id="CARD-DECK-HEADER-ACTIONS-QUICK-CAPTURE-BUTTON-FOR-{~D:Record.Macro.RawHTMLID~}"
										class="button is-clickable is-link is-skeleton"
										style="border-left: 1px solid var(--bulma-border);"
									>
										<input
											title="Quick Capture - Take a photo with your device's camera"
											type="file"
											class="file-input"
											name="user"
											capture="environment"
											accept="image/*"
											onchange="_Pict.providers.ObservationCardDeckProvider.handleAddNewCardToDeckButtonEvent(event, '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', true)"
										/>
											<div class="{~Hide:Record.PictForm.CardDeckSettings.customIconClassForQuickCaptureButton~} mr-2">
												<i class="fas fa-fw fa-camera"></i>
											</div>
											<div class="{~Show:Record.PictForm.CardDeckSettings.customIconClassForQuickCaptureButton~} mr-2">
												<i class="fa fa-fw {~D:Record.PictForm.CardDeckSettings.customIconClassForQuickCaptureButton~}"></i>
											</div>
											<span class="icon-text {~Hide:Record.PictForm.CardDeckSettings.customTextForQuickCaptureButton~}">Quick Capture</span>
											<span class="icon-text {~Show:Record.PictForm.CardDeckSettings.customTextForQuickCaptureButton~}">{~D:Record.PictForm.CardDeckSettings.customTextForQuickCaptureButton~}</span>
									</label>
								</div>
							</div>
						</div>
						<!-- content area below the header - appears a the card deck body where the observation cards get rendered -->
						<p class="control control-status">
							<span class="control-status-icon"></span>
							<!-- container for the body of the card deck where the observation cards will be rendered -->
							<div id="CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}" class="observation-card-deck-body" {~D:Record.Macro.ControlAttr~}><span class="initial-loading-message"><i class="fa fa-fw fa-circle-notch fa-spin"></i></span></div>
							<!-- Empty message for when there are no observations -->
							<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="observation-card-deck-empty-message">
								<div class="has-text-centered">
									<span class="icon">
										<i class="fa fa-fw fa-info-circle"></i>
									</span>
									<span class="icon-text {~Hide:Record.PictForm.CardDeckSettings.customEmptyStateMessage~}">No items have been added to this collection.</span>
									<span class="icon-text {~Show:Record.PictForm.CardDeckSettings.customEmptyStateMessage~}">{~D:Record.PictForm.CardDeckSettings.customEmptyStateMessage~}</span>
								</div>
							</div>
						</p>
					</div>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationCardDeck',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
			<!-- InputType ObservationCardDeck {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}" id="CARD-DECK-CONTAINER-FOR-{~D:Record.Macro.RawHTMLID~}">
				<div class="field">
					<label id="LABEL-FOR-{~D:Record.Macro.RawHTMLID~}" for="CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} mr-4">{~LabelWithChips:Record~}</label>
					<!-- Hidden input to store/validate the observation card deck Observation Set (if using Observation Sets, if not, this will remain empty and unused) -->
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="text"
						class="input is-hidden"
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.InputFullProperties~}
						{~D:Record.Macro.InputChangeHandler~}
						value=""
					/>
					<!-- Card Deck UI -->
					<div class="observation-card-deck">
						<div class="observation-card-deck-header">
							<!-- container for filter tags that get dynamically generated based on the filters applied to the deck, if any -->
							<div id="CARD-DECK-HEADER-FILTERS-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-filters {~Hide:Record.PictForm.CardDeckSettings.useObservationSetSelector~}"></div>
							<!-- hidden input to store the currently selected observation set to exclude from the card deck, used when showSetSelector option is true and the user selects a set to exclude from the deck via the filter dropdown -->
							<input id="CARD-DECK-HEADER-EXCLUDE-OBSERVATION-SET-HIDDEN-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" type="hidden" value="{~D:Record.PictForm.CardDeckSettings.excludeObservationSets~}"/>
							<!-- static content in the header that shows the current set name if using a set without the set selector (gray tags similar to filter tags) -->
							<div id="CARD-DECK-HEADER-OBSERVATION-SET-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-observation-set-display {~Hide:Record.PictForm.CardDeckSettings.useObservationSetSelector~}"></div>
							<!-- Action buttons for the card deck -->
							<div id="CARD-DECK-HEADER-ACTIONS-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-actions">
								<div class="buttons has-addons observation-card-deck-style-toggle mr-1 mb-0">
									<button type="button" 
										class="button is-active" 
										title="Thumbnail" 
										data-deck-style="thumbnail" 
										onclick="_Pict.providers.ObservationCardDeckProvider.toggleDeckStyle('CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}', 'thumbnail')">
										<span class="icon">
											<i class="fa fa-fw fa-th"></i>
										</span>
									</button>
									<button type="button"
										class="button"
										title="List"
										data-deck-style="list"
										onclick="_Pict.providers.ObservationCardDeckProvider.toggleDeckStyle('CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}', 'list')">
										<span class="icon">
											<i class="fa fa-fw fa-list"></i>
										</span>
									</button>
									<button type="button"
										class="button"
										title="Details"
										data-deck-style="details"
										onclick="_Pict.providers.ObservationCardDeckProvider.toggleDeckStyle('CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}', 'details')">
										<span class="icon">
											<i class="fa fa-fw fa-id-card"></i>
										</span>
									</button>
								</div>
							</div>
						</div>
						<!-- content area below the header - appears a the card deck body where the observation cards get rendered -->
						<p class="control">
							<!-- container for the body of the card deck where the observation cards will be rendered -->
							<div id="CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}" class="observation-card-deck-body" {~D:Record.Macro.ControlAttr~}><span class="initial-loading-message"><i class="fa fa-fw fa-circle-notch fa-spin"></i></span></div>
							<!-- Empty message for when there are no observations -->
							<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="observation-card-deck-empty-message">
								<div class="has-text-centered">
									<span class="icon">
										<i class="fa fa-fw fa-info-circle"></i>
									</span>
									<span class="icon-text {~Hide:Record.PictForm.CardDeckSettings.customEmptyStateMessage~}">No items have been added to this collection.</span>
									<span class="icon-text {~Show:Record.PictForm.CardDeckSettings.customEmptyStateMessage~}">{~D:Record.PictForm.CardDeckSettings.customEmptyStateMessage~}</span>
								</div>
							</div>
						</p>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationCardDeck',
			DefaultInputExtensions: [ 'ObservationCardDeckProvider' ],
			Template: /*HTML*/`
			<!-- InputType ObservationCardDeck {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} for-print-only" id="CARD-DECK-CONTAINER-FOR-{~D:Record.Macro.RawHTMLID~}">
				<div class="field">
					<label id="LABEL-FOR-{~D:Record.Macro.RawHTMLID~}" for="CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~} mr-4">{~LabelWithChips:Record~}</label>
					<!-- Hidden input to store/validate the observation card deck Observation Set (if using Observation Sets, if not, this will remain empty and unused) -->
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="text"
						class="input is-hidden"
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.InputFullProperties~}
						{~D:Record.Macro.InputChangeHandler~}
						value=""
					/>
					<!-- Card Deck UI -->
					<div class="observation-card-deck">
						<div class="observation-card-deck-header">
							<!-- container for filter tags that get dynamically generated based on the filters applied to the deck, if any -->
							<div id="CARD-DECK-HEADER-FILTERS-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-filters {~Hide:Record.PictForm.CardDeckSettings.useObservationSetSelector~}"></div>
							<!-- hidden input to store the currently selected observation set to exclude from the card deck, used when showSetSelector option is true and the user selects a set to exclude from the deck via the filter dropdown -->
							<input id="CARD-DECK-HEADER-EXCLUDE-OBSERVATION-SET-HIDDEN-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}" type="hidden" value="{~D:Record.PictForm.CardDeckSettings.excludeObservationSets~}"/>
							<!-- static content in the header that shows the current set name if using a set without the set selector (gray tags similar to filter tags) -->
							<div id="CARD-DECK-HEADER-OBSERVATION-SET-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}" class="card-deck-header-observation-set-display {~Hide:Record.PictForm.CardDeckSettings.useObservationSetSelector~}"></div>
						</div>
						<!-- content area below the header - appears a the card deck body where the observation cards get rendered -->
						<div class="control">
							<!-- container for the body of the card deck where the observation cards will be rendered -->
							<div id="CARD-DECK-CONTENT-FOR-{~D:Record.Macro.RawHTMLID~}" class="observation-card-deck-body" {~D:Record.Macro.ControlAttr~}></div>
							<!-- Empty message for when there are no observations -->
							<div id="EMPTY-MESSAGE-FOR-{~D:Record.Macro.RawHTMLID~}" class="observation-card-deck-empty-message">
								<div class="has-text-centered">
									<span class="icon">
										<i class="fa fa-fw fa-info-circle"></i>
									</span>
									<span class="icon-text {~Hide:Record.PictForm.CardDeckSettings.customEmptyStateMessageForPrint~}">{~D:Record.PictForm.CardDeckSettings.customEmptyStateMessage:No items have been added to this collection.~}</span>
									<span class="icon-text {~Show:Record.PictForm.CardDeckSettings.customEmptyStateMessageForPrint~}">{~D:Record.PictForm.CardDeckSettings.customEmptyStateMessageForPrint~}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
